var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeedback = function SvgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Feedback_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 19c5.222 0 9-3.822 9-8s-3.778-8-9-8c-5.222 0-9 3.822-9 8 0 2.132.942 4.113 2.57 5.592A4.331 4.331 0 0 1 7 19.72l.95-.46 1.305 2.702-3.461 1.672A1.25 1.25 0 0 1 4 22.508V19.79c0-.374-.17-.726-.448-.977C1.36 16.819 0 14.055 0 11 0 4.925 5.373 0 12 0s12 4.925 12 11-5.373 11-12 11c-.672 0-1.332-.05-1.974-.148a1.317 1.317 0 0 0-.77.11L7.95 19.261a4.316 4.316 0 0 1 2.526-.375C10.97 18.96 11.48 19 12 19",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Feedback_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgFeedback;